import axios from "axios"
import { ticketBaseURL } from "../config/api";

export const put_Address = (data: any, userId: number) => {
    return axios({
        url: `${ticketBaseURL}mycdirAddress?userId=${userId}`,
        method: "PUT",
        headers: {          
            "Content-Type": "application/json"
        },
        withCredentials: true,
        data: data
    }).then(response => response.data);
}

export const getMyCdirAddressByTenantId = (tenantId: string) => {
    return getFetch(`mycdirAddress/GetMycdirAddressByTenantId/${tenantId}`)
}

const getFetch = (url: string, params = {}) => {
    return axios({
        url: ticketBaseURL + url,
        method: "GET",
        headers: {          
            'Content-Type': 'application/json'
        },
        params: params
    }).then(response => response.data);
}